"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-card-view-v2.tsx
var CardViewV2 = function CardViewV2(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M3.60001 10.8V3.60001H10.8V10.8H3.60001ZM3.60001 20.4V13.2H10.8V20.4H3.60001ZM13.2 10.8V3.60001H20.4V10.8H13.2ZM13.2 20.4V13.2H20.4V20.4H13.2ZM5.40001 9.00001H9.00001V5.40001H5.40001V9.00001ZM15 9.00001H18.6V5.40001H15V9.00001ZM15 18.6H18.6V15H15V18.6ZM5.40001 18.6H9.00001V15H5.40001V18.6Z",
    fill: "currentColor"
  }));
};

var _default = CardViewV2;
exports.default = _default;